/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionErrorDetailsPayerNotFound } from './PalAuthSubmissionErrorDetailsPayerNotFound';
import {
    PalAuthSubmissionErrorDetailsPayerNotFoundFromJSON,
    PalAuthSubmissionErrorDetailsPayerNotFoundFromJSONTyped,
    PalAuthSubmissionErrorDetailsPayerNotFoundToJSON,
    PalAuthSubmissionErrorDetailsPayerNotFoundToJSONTyped,
} from './PalAuthSubmissionErrorDetailsPayerNotFound';

/**
 * 
 * @export
 * @interface PalAuthSubmissionErrorDetails
 */
export interface PalAuthSubmissionErrorDetails {
    /**
     * 
     */
    diagnosis_not_found?: string;
    /**
     * 
     */
    invalid_servicing_provider_name?: string;
    /**
     * 
     */
    platform_message?: string;
    /**
     * 
     */
    payer_not_found?: PalAuthSubmissionErrorDetailsPayerNotFound;
}

/**
 * Check if a given object implements the PalAuthSubmissionErrorDetails interface.
 */
export function instanceOfPalAuthSubmissionErrorDetails(value: object): value is PalAuthSubmissionErrorDetails {
    return true;
}

export function PalAuthSubmissionErrorDetailsFromJSON(json: any): PalAuthSubmissionErrorDetails {
    return PalAuthSubmissionErrorDetailsFromJSONTyped(json, false);
}

export function PalAuthSubmissionErrorDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionErrorDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnosis_not_found': json['diagnosis_not_found'] == null ? undefined : json['diagnosis_not_found'],
        'invalid_servicing_provider_name': json['invalid_servicing_provider_name'] == null ? undefined : json['invalid_servicing_provider_name'],
        'platform_message': json['platform_message'] == null ? undefined : json['platform_message'],
        'payer_not_found': json['payer_not_found'] == null ? undefined : PalAuthSubmissionErrorDetailsPayerNotFoundFromJSON(json['payer_not_found']),
    };
}

export function PalAuthSubmissionErrorDetailsToJSON(json: any): PalAuthSubmissionErrorDetails {
    return PalAuthSubmissionErrorDetailsToJSONTyped(json, false);
}

export function PalAuthSubmissionErrorDetailsToJSONTyped(value?: PalAuthSubmissionErrorDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnosis_not_found': value['diagnosis_not_found'],
        'invalid_servicing_provider_name': value['invalid_servicing_provider_name'],
        'platform_message': value['platform_message'],
        'payer_not_found': PalAuthSubmissionErrorDetailsPayerNotFoundToJSON(value['payer_not_found']),
    };
}

